import GeographicLocationPicker, { GeographicAddress } from './GeographicLocationPicker';

export type { GeographicAddress } from './GeographicLocationPicker';

interface Props { value: GeographicAddress; onChange: (value: GeographicAddress) => void; disabled?: boolean; error?: string }
export default function AddressAutocomplete({ value, onChange, ...props }: Props) {
  return <GeographicLocationPicker {...props} singleSelect value={value.countryId ? [value] : []}
    onChange={values => onChange(values[0] ?? { countryId: '', adminAreaId: '', localityId: '' })} />;
}
